class ModuleClass {
  constructor(scope) {
    this.scope = scope;
  }

  /**
   * Formatea la etiqueta de un módulo.
   * @param {Array} modules - un conjunto de módulos
   * @returns {Array} una matriz de módulos con sus etiquetas formateadas
   */
  formatLabelModule(modules) {
    return modules.map((module) => {
      const name = `${module.id} - ${this.scope.translateDataBaseText(
        module.name,
        module.other_value
      )}`;

      return { ...module, name };
    });
  }
}

export default ModuleClass;
